import {
  setInterval as workerSetInterval,
  clearInterval as workerClearInterval,
} from 'worker-timers';

import LoggingUtil from './logging-util';

class TimerUtil {
  private timerId: number | null = null;
  private useWorkerTimers: boolean;

  constructor(
    private callback: () => void,
    private delay: number,
    private logger: LoggingUtil,
  ) {
    this.logger = logger;
    this.useWorkerTimers = typeof workerSetInterval === 'function';
    this.logger.log('debug', `Timer initialized. Interval: ${this.delay}ms.`);
  }

  start(): void {
    this.stop();
    if (this.useWorkerTimers) {
      try {
        this.logger.log('debug', 'Starting worker timer.');
        this.timerId = workerSetInterval(this.callback, this.delay);
      } catch {
        this.logger.log('warn', 'Worker timer failed; using native timer.');
        this.timerId = window.setInterval(this.callback, this.delay);
        this.useWorkerTimers = false;
      }
    } else {
      this.logger.log('info', 'Using native timer.');
      this.timerId = window.setInterval(this.callback, this.delay);
    }
  }

  stop(): void {
    if (this.timerId !== null) {
      if (this.useWorkerTimers) {
        workerClearInterval(this.timerId);
      } else {
        window.clearInterval(this.timerId);
      }
      this.logger.log('debug', 'Timer stopped.');
      this.timerId = null;
    }
  }
}

export default TimerUtil;
